import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-common-search',
  templateUrl: './common-component-search.component.html',
  styleUrls: ['./common-component-search.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatIcon],
})
export class CommonSearchComponent implements OnInit, OnChanges {
  @Input() initialSearchValue = ''; // Input for initial value
  @Input() placeHolder = '';
  @Output() searchSubmit = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<void>();

  searchForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.searchForm = this.formBuilder.group({
      searchInput: [''],
    });
  }

  ngOnInit(): void {
    // Set the initial value for the search box
    this.searchForm.get('searchInput')?.setValue(this.initialSearchValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['initialSearchValue'] &&
      !changes['initialSearchValue'].firstChange
    ) {
      this.searchForm
        .get('searchInput')
        ?.setValue(this.initialSearchValue || '');
    }
  }

  onSearch(event): void {
    this.performSearch();
    event.preventDefault();
  }

  onSearchClick(): void {
    this.performSearch();
  }

  private performSearch(): void {
    const searchTerm = this.searchForm.get('searchInput')?.value.trim();
    if (searchTerm) {
      this.searchSubmit.emit(searchTerm);
    } else {
      this.searchSubmit.emit('');
    }
  }

  onClear(event): void {
    this.performClear();
    event.preventDefault();
  }

  private performClear(): void {
    const searchTerm = this.searchForm.get('searchInput')?.value.trim();
    if (!searchTerm) {
      this.cleared.emit();
    }
  }
}
